export interface IAudioPlayButton {
    pause: () => void;
    play: () => void;
}

export const AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT = "data-disable-pause";

export const AUDIO_BUTTON_PLAY_EVENT = "audioPlayButtonStarted";

export interface AudioButtonPlayEventInterface {
    instance: any,
    audio: HTMLAudioElement
}